import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

/** Fetches a read-only /api/gsheet/<resource> dataset with loading/error/refresh state. */
export function useGSheet(resource) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get(`/gsheet/${resource}`);
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "No se pudieron cargar los datos.");
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [resource]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, refresh: load };
}
